import { render, staticRenderFns } from "./KPIChartCard.vue?vue&type=template&id=b718c25c"
import script from "./KPIChartCard.vue?vue&type=script&lang=js"
export * from "./KPIChartCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports